export enum SupportedLangsEnum {
  uk = 'uk',
  pl = 'pl',
  es = 'es',
  en = 'en',

  // work in progress
  // de = 'de',
  // fr = 'fr',
}

export type SupportedLangsType = keyof typeof SupportedLangsEnum;
